import React, {useEffect, useRef, useState} from "react";
import Header from "../components/header";
import Navigation from "../components/navigation";
import {DatePicker} from "rsuite";
import 'rsuite/dist/rsuite.min.css';
import "react-toastify/dist/ReactToastify.css";
import {addUpdateUserEmailFilters, deleteUserEmailFilters, fetchEmailFiltersLookupData} from "../server-calls";
import StateManager from "../redux/StateManager";
import {toast, ToastContainer} from "react-toastify";
import {updateCache} from "../idb";

export default function FilterManager() {

    const TOAST_CONTAINER_ID = "filters-toast-container"
    const navigationRef = useRef()

    function startSocket() {
        if (StateManager.isCacheComplete())
            navigationRef.current?.handleSocket()
    }

    const [filters, setFilters] = useState([]);

    const [mailboxes, setMailboxes] = useState([]);

    const [existingFiltersFound, setExistingFiltersFound] = useState(false)

    useEffect(() => {
        startingOperations()
    }, []);

    async function startingOperations() {
        toast.loading("loading data", {containerId: TOAST_CONTAINER_ID})

        const lookupData = await fetchEmailFiltersLookupData(StateManager.getToken())

        let mailBoxesExtracted = []

        lookupData.boxes.forEach((box) => {
            mailBoxesExtracted.push(box.name)
        })
        setMailboxes(mailBoxesExtracted)

        const existing = lookupData.filters;
        if (existing && existing.filters) {
            setFilters(JSON.parse(existing.filters));
            setExistingFiltersFound(true)
        }
        startSocket()
        toast.dismiss({containerId: TOAST_CONTAINER_ID})
    }

    const updateFilter = (index, updatedFilter) => {
        const newFilters = [...filters];
        newFilters[index] = updatedFilter;
        setFilters(newFilters);
    };

    const removeFilter = (index) => {
        const newFilters = filters.filter((_, i) => i !== index);
        setFilters(newFilters);
    };

    const addFilter = () => {
        setFilters([
            ...filters,
            {
                type: "reject",
                condition: {
                    field: "subject",
                    op: "includes",
                    value: ""
                }
            }
        ]);
    };

    const saveFilters = async () => {
        toast.loading("Saving filters", {containerId: TOAST_CONTAINER_ID})
        await addUpdateUserEmailFilters(StateManager.getToken(), {filters: JSON.stringify(filters)})
        toast.dismiss({id: undefined, containerId: TOAST_CONTAINER_ID})
        toast.success(`Filters saved.`, {containerId: TOAST_CONTAINER_ID})
    };

    const deleteFilters = async () => {
        toast.loading("Deleting filters", {containerId: TOAST_CONTAINER_ID})
        await deleteUserEmailFilters(StateManager.getToken())
        toast.dismiss({id: undefined, containerId: TOAST_CONTAINER_ID})
        setFilters([])
        toast.success("Filters deleted perfect.", {containerId: TOAST_CONTAINER_ID})
    }

    const renderConditionField = (filter, index) => {
        const {field, op, value} = filter.condition;

        if (field === "date" && op === "between") {
            return (
                <div className="d-flex gap-2">
                    <DatePicker
                        placeholder="Start Date"
                        defaultValue={value[0] ? new Date(value[0]) : null}
                        onChange={date => {
                            const updated = {...filter};
                            updated.condition.value = `${date.toISOString()},`;
                            updateFilter(index, updated);
                        }}
                    />
                    <DatePicker
                        placeholder="End Date"
                        defaultValue={value[1] ? new Date(value[1]) : null}
                        onChange={date => {
                            const updated = {...filter};
                            updated.condition.value += date.toISOString();
                            updateFilter(index, updated);
                        }}
                    />
                </div>
            );
        } else {
            return (
                <input
                    type="text"
                    value={Array.isArray(value) ? value.join(", ") : value}
                    onChange={(e) => {
                        const updated = {...filter};
                        updated.condition.value =
                            field === "cc" || filter.type === "forward"
                                ? e.target.value.split(",").map(s => s.trim())
                                : e.target.value;
                        updateFilter(index, updated);
                    }}
                />
            );
        }
    };

    const renderExtraFields = (filter, index) => {
        switch (filter.type) {
            case "saveTo":
                return (
                    <select
                        value={filter.targetBox || ""}
                        onChange={(e) => {
                            const updated = {...filter, targetBox: e.target.value};
                            updateFilter(index, updated);
                        }}
                    >
                        <option value="">Select Mailbox</option>
                        {mailboxes.map((box, idx) => (
                            <option key={idx} value={box}>{box}</option>
                        ))}
                    </select>
                );
            case "reply":
                return (
                    <div className="d-flex flex-column">
                        <input
                            type="text"
                            placeholder="Auto-Reply Subject"
                            value={filter.replySubject || ""}
                            onChange={(e) => {
                                const updated = {...filter, replySubject: e.target.value};
                                updateFilter(index, updated);
                            }}
                        />
                        <textarea
                            placeholder="Auto-Reply Body"
                            value={filter.replyBody || ""}
                            onChange={(e) => {
                                const updated = {...filter, replyBody: e.target.value};
                                updateFilter(index, updated);
                            }}
                        />
                    </div>
                );
            case "forward":
                return (
                    <input
                        type="text"
                        placeholder="Forward To (comma-separated)"
                        value={filter.forwardTo?.join(", ") || ""}
                        onChange={(e) => {
                            const updated = {...filter, forwardTo: e.target.value.split(",").map(s => s.trim())};
                            updateFilter(index, updated);
                        }}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <>
            <Header/>
            <div className="container-fluid" style={{height: "95vh"}}>
                <div style={{height: "95vh"}} className="row">
                    <div className="col-md-1 p-0">
                        <Navigation ref={navigationRef} handlerFunction={updateCache}/>
                    </div>
                    <div style={{maxHeight: "95vh", overflow: "scroll"}} className="col-md-11">
                        <h4>Email Filters</h4>
                        {filters.map((filter, index) => (
                            <div key={index} className="mb-4 border-bottom pb-3">
                                <div className="d-flex gap-3 mb-2 flex-wrap align-items-center">
                                    <select
                                        value={filter.type}
                                        onChange={(e) => {
                                            const updated = {...filter, type: e.target.value};
                                            updateFilter(index, updated);
                                        }}
                                    >
                                        <option value="reject">Reject</option>
                                        <option value="saveTo">Save to Mbox</option>
                                        <option value="forward">Forward</option>
                                        <option value="reply">Auto Reply</option>
                                    </select>

                                    <select
                                        value={filter.condition.field}
                                        onChange={(e) => {
                                            const updated = {...filter};
                                            updated.condition.field = e.target.value;
                                            updateFilter(index, updated);
                                        }}
                                    >
                                        <option value="from">From</option>
                                        <option value="subject">Subject</option>
                                        <option value="body">Body</option>
                                        <option value="date">Date</option>
                                    </select>

                                    <select
                                        value={filter.condition.op}
                                        onChange={(e) => {
                                            const updated = {...filter};
                                            updated.condition.op = e.target.value;
                                            updated.condition.value = e.target.value === "between" ? ["", ""] : "";
                                            updateFilter(index, updated);
                                        }}
                                    >
                                        <option value="includes">Includes</option>
                                        <option value="equals">Equals</option>
                                        <option value="between">Between</option>
                                    </select>

                                    {renderConditionField(filter, index)}

                                    {renderExtraFields(filter, index)}

                                    <button
                                        className="btn btn-danger btn-sm"
                                        onClick={() => removeFilter(index)}
                                    >
                                        Remove
                                    </button>
                                </div>
                            </div>
                        ))}
                        <button className="btn btn-primary btn-sm" onClick={addFilter}>Add Filter</button>
                        <br></br><br></br>
                        {filters.length > 0 && (
                            <button className="btn btn-primary btn-sm" onClick={saveFilters}>Save Filters</button>)}
                        {existingFiltersFound && (<>&nbsp;&nbsp;
                            <button className="btn btn-danger btn-sm" onClick={deleteFilters}>Delete Filters</button>
                        </>)}
                    </div>
                </div>
            </div>
            <ToastContainer containerId={TOAST_CONTAINER_ID}/>
        </>
    );
}
